import React from 'react';


export type TranslatableErrorShape = {
  title?: string;
  body: string;
};


export const useTranslatableErrors = (
  errors: Record<string, TranslatableErrorShape>,
  error?: string
) => React.useMemo<TranslatableErrorShape>(() => {
  return errors[error ?? ''] || { body: error };
}, [ errors, error ]);
